// Lógica pura de disponibilidade de horários — sem acesso à base de dados,
// para ser facilmente testável. Usada por src/lib/supabase.js.

// Gera os horários candidatos do dia, do horário de abertura ao de fecho,
// de `slotMinutos` em `slotMinutos`, incluindo apenas os que cabem (com a
// duração do serviço) até à hora de fecho.
export function gerarSlots(data, horaAbertura, horaFecho, slotMinutos, duracaoMin) {
  const [hA, mA] = horaAbertura.split(':').map(Number)
  const [hF, mF] = horaFecho.split(':').map(Number)
  const slot = parseInt(slotMinutos)

  const base = new Date(data); base.setHours(hA, mA, 0, 0)
  const fim = new Date(data); fim.setHours(hF, mF, 0, 0)

  const slots = []
  let cursor = new Date(base)
  while (cursor < fim) {
    const slotFim = new Date(cursor.getTime() + duracaoMin * 60000)
    if (slotFim <= fim) slots.push(new Date(cursor))
    cursor = new Date(cursor.getTime() + slot * 60000)
  }
  return slots
}

// Verdade se [aInicio,aFim) e [bInicio,bFim) se sobrepõem.
function sobrepoe(aInicio, aFim, bInicio, bFim) {
  return aInicio < bFim && aFim > bInicio
}

// Filtra os slots removendo: passado/antecedência, almoço, colisão com
// ocupados (marcações + bloqueios) e excesso de capacidade por categoria.
export function filtrarSlots(slots, {
  duracaoMin,
  ocupados = [],
  agora = new Date(),
  antecedenciaMs = 0,
  almocoInicio = null,
  almocoFim = null,
  capacidade = Infinity,
  agendamentosCategoria = [],
}) {
  return slots.filter(slot => {
    if (slot.getTime() <= agora.getTime() + antecedenciaMs) return false
    const slotFim = new Date(slot.getTime() + duracaoMin * 60000)

    if (almocoInicio && almocoFim && sobrepoe(slot, slotFim, almocoInicio, almocoFim)) return false

    const colide = ocupados.some(o =>
      sobrepoe(slot, slotFim, new Date(o.data_hora_inicio), new Date(o.data_hora_fim))
    )
    if (colide) return false

    if (capacidade !== Infinity) {
      const sobrepostos = agendamentosCategoria.filter(a =>
        sobrepoe(slot, slotFim, new Date(a.data_hora_inicio), new Date(a.data_hora_fim))
      ).length
      if (sobrepostos >= capacidade) return false
    }

    return true
  })
}

// Escolhe a primeira sala da categoria que esteja livre no intervalo pedido.
// `ocupacao` são as marcações do dia (com sala_id e categoria). Devolve o id
// da sala livre ou null se não houver nenhuma.
export function escolherSala(salas, ocupacao, categoria, inicio, fim) {
  if (!salas || salas.length === 0) return null
  const ocupadas = new Set(
    (ocupacao || [])
      .filter(a =>
        a.categoria === categoria &&
        sobrepoe(new Date(a.data_hora_inicio), new Date(a.data_hora_fim), inicio, fim)
      )
      .map(a => a.sala_id)
      .filter(Boolean)
  )
  return salas.find(s => !ocupadas.has(s.id))?.id || null
}
